import React from "react";
import PropTypes from "prop-types";
import Button from "ui/Button";
import GroupPreview from "components/GroupPreview";
import { inviteGroup } from "domain/Game/api";

const InvitationsModalGroupListItem = ({
    invited,
    group,
    gameId,
    updateGameData,
    handleClickItem,
    textButton,
    activeTextButton,
}) => {
    const handleClick = async () => {
        if (handleClickItem) {
            return handleClickItem(group);
        }

        const request = await inviteGroup(gameId, group.id);
        updateGameData(request.game);
    };

    return (
        <div className="players-list__item  players-list__item_with-padding">
            <GroupPreview {...group} />

            <div className="players-list__right">
                <Button
                    size="small"
                    text
                    disabled={invited}
                    onClick={handleClick}
                >
                    <span>{!invited ? textButton : activeTextButton}</span>
                </Button>
            </div>
        </div>
    );
};

InvitationsModalGroupListItem.propTypes = {
    invited: PropTypes.bool,
    group: PropTypes.object,
    gameId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    updateGameData: PropTypes.func.isRequired,
    handleClickItem: PropTypes.func,
    activeTextButton: PropTypes.string,
    textButton: PropTypes.string,
};

export default InvitationsModalGroupListItem;
